import(/* webpackMode: "eager" */ "/vercel/path0/app/restaurant-login/page.tsx");
